import './App.css';
import Weather from './Weather';
function App() {
  return (
    <div className="App">
      <div className='container'>
        <Weather defaultCity="New York" />
      <footer>
        This project was coded by{" "}
        <a 
        href='https://github.com/Sarina-Karimi/'
        target='_blank'
        rel="noopener noreferrer"
        >Sarina Karimi</a>
        {" "} and is{" "}
        <a href='https://github.com/Sarina-Karimi/week-five-react-project'
        target='_blank'
        rel='noopener noreferrer'
        >open-sourced on GitHub</a> {" "} and 
        <a 
        href='https://app.netlify.com/projects/weekfivereactweatherapp/overview' 
        target='_blank'
        rel='noopener noreferrer'
        >hosted on Netlify.</a>
      </footer>
      </div>
    </div>
  );
}

export default App;
